import React from 'react'
import {useParams} from 'react-router-dom';
import { EpicSpinner } from '../../components';
import './JobProgressPage.scss'
import {JobProgressStatus} from '../../components/JobProgressStatus';

const JobProgressPage = () => {
  const {id} = useParams()

  return (
    <div className="job-progress">
      {id && <JobProgressStatus jobId={id}/>}
      <EpicSpinner />
    </div>
  )
}

export default JobProgressPage